import React from 'react';

const SessionExpired = () => (
  <div className="general-info-page page-without-secondary-menu page-content-container">
    <div className="general-info-text">
      This user account is logged into another session.<br />
      This session is not valid anymore.<br />
      You may close this tab and use another one.
    </div>
  </div>
);

export default SessionExpired;
